module.exports = __webpack_public_path__ + "img/translationeditor_11.aa6143c5.jpg";